import React from 'react'

import AuthUserContext from './context'
import { baseUrl as portalUrl } from '../../Portal/config'

const AVATAR_KEY = 'avatar'
const AUTH_KEY = 'auth'

const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props)
            this.state = {
                auth: localStorage.getItem(AUTH_KEY),
                avatar: localStorage.getItem(AVATAR_KEY)
            }
        }
        fetchAvatar() {
            fetch(portalUrl)
                .then(res => res.json())
                .then(data => {
                    const { portalLogo } = data
                    const avatar = portalLogo && portalLogo !== 'portal_logo.png' ? `/uploads/images/logos/${portalLogo}` : null
                    this.setState({ avatar })
                })
                .catch((err) => console.log('err', err))
        }
        componentDidMount() {
            if (!this.state.avatar) {
                this.fetchAvatar()
            }
        }
        componentDidUpdate() {
            const { auth, avatar } = this.state
            if (auth) {
                localStorage.setItem(AUTH_KEY, auth)
            }
            if (avatar) {
                localStorage.setItem(AVATAR_KEY, avatar)
            }
        }
        logout() {
            localStorage.removeItem(AUTH_KEY)
            localStorage.removeItem(AVATAR_KEY)
            this.setState({
                auth: null,
                avatar: null
            })
        }
        render() {
            const authUserContextData = {
                auth: this.state.auth,
                avatar: this.state.avatar,
                login: () => this.setState({ auth: 1 }),
                logout: () => this.logout(),
                fetchAvatar: () => this.fetchAvatar(),
            }
            return (
                <AuthUserContext.Provider value={authUserContextData}>
                    <Component {...this.props} />
                </AuthUserContext.Provider>
            )
        }
    }
    return WithAuthentication
}

export default withAuthentication